import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Banner from './Banner';
import PrivacyPolicyInfo from './PrivacyPolicyInfo';
class PrivacyPolicy extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
}


  render() {
    return (
        <div className="container-xxl bg-white p-0">
          <Spinner/>
          <TopMenu title="Privacy Policy"/>
          <PrivacyPolicyInfo/>
          <Footer />
        </div>
    );
  }
}

export default PrivacyPolicy;
